import { createRef } from "react";
import { useStyles } from "./TakisDivider.styles";
import PropTypes from "prop-types";
import { ReactComponent as DividerVariationOne } from "../assets/images/dividerVariation1.svg";
import { ReactComponent as DividerVariationTwo } from "../assets/images/dividerVariation2.svg";
import { ReactComponent as DividerVariationThree } from "../assets/images/dividerVariation3.svg";
import { ReactComponent as DividerVariationFour } from "../assets/images/dividerVariation4.svg";
import { ReactComponent as DividerVariationFive } from "../assets/images/dividerVariation5.svg";

export default function TakisDivider({
  variation = 0,
  modifier,
  marginModifier,
  backgroundColor,
  isProductPage
}) {
  const classes = useStyles();
  const dividerVariation = createRef();

  TakisDivider.propTypes = {
    modifier: PropTypes.string,
    marginModifier: PropTypes.string,
    variation: PropTypes.number,
    backgroundColor: PropTypes.string,
  };

  const getDividerVariation = () => {
    switch (variation) {
      case 1:
        return (
          <DividerVariationOne
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
      case 2:
        return (
          <DividerVariationTwo
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
      case 3:
        return (
          <DividerVariationThree
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
      case 4:
        return (
          <DividerVariationFour
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
      case 5:
        return (
          <DividerVariationFive
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
      default:
        return (
          <DividerVariationOne
            ref={dividerVariation}
            className={`${classes.takisDividerImage}`}
            />
        );
    }
  };

  return (
    <div
      className={`${classes.takisDivider} ${modifier || ""} ${isProductPage ? classes.svgTranslation : ""} ${
        classes[backgroundColor] || ""
      }`}
    >
      {getDividerVariation()}
      {!isProductPage &&
      <div
        className={`${classes.takisDividerMargin} ${marginModifier || ""}`}
      />}
    </div>
  );
}
